import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalContent } from 'src/app/core/interface';
import {
  AlertItem, AlertType, Appraisal, Calibration,
  Company, Contract, Equipment, Lane, Spot, User
} from 'src/app/core/models';
import {
  AlertService, AppraisalService,
  CalibrationService,
  CompanyService,
  ContractGlobalService, ContractService,
  EquipmentModelService,
  EquipmentService,
  LaneService, ManufacturerService, ModalService, SpotService,
  StorageKey,
  StorageService,
  UserService
} from 'src/app/core/services';
import { BaseModal } from 'src/app/core/utils/BaseModal';
import { validateDate } from 'src/app/core/utils/validateDate';
import moment from 'moment';
import { timeStamp } from 'console';

@Component({
  selector: 'app-appraisal-create-or-update',
  templateUrl: './appraisal-create-or-update.component.html',
  styleUrls: ['./appraisal-create-or-update.component.sass']
})
export class AppraisalCreateOrUpdateComponent extends BaseModal implements OnInit, ModalContent {
  public appraisal: Appraisal = new Appraisal();
  public appraisalForm: FormGroup;
  public spots: Array<Spot> = [];
  public equipments: Array<Equipment> = [];
  public allEquipments: Array<Equipment> = [];
  public allSpots: Array<Spot> = [];
  public lanes: Array<Lane> = [];
  public allLanes: Array<Lane> = [];
  public calibrations: Array<Calibration> = [];
  public allCalibrations: Array<Calibration> = [];
  public contracts: Array<Contract> = [];
  public contractGlobal = null;
  public users: Array<User> = [];
  public equipmentModelCategory = null;
  public lane = new Lane();
  public companies: Array<Company>;
  public typeUnfoldEquipment = 'more';
  public typeUnfoldLocal = 'more';
  public typeUnfoldCompanyManufacturer = 'more';
  public typeUnfoldCompanyResponsible = 'more';
  public typeUnfoldAssign = 'more';
  public promise: Promise<any>;
  public isValid = false;
  public isSaveLocalStorage = true;
  public technicianUserId = null;
  public loading = false;

  get lastState(): any {
    throw new Error('Method not implemented.');
  }
  constructor(
    public modalService: ModalService,
    private formBuilder: FormBuilder,
    private spotService: SpotService,
    private laneService: LaneService,
    private userService: UserService,
    private contractService: ContractService,
    private appraisalService: AppraisalService,
    private contractsGlobalService: ContractGlobalService,
    private equipmentService: EquipmentService,
    private calibrationService: CalibrationService,
    private storageService: StorageService,
    private equipmentModelService: EquipmentModelService,
    private manufacturerService: ManufacturerService,
    private companyService: CompanyService,
    private alertService: AlertService,
  ) {
    super(modalService);
    if (this.contractsGlobalService.contracts != null) {
      this.contractGlobal = this.contractsGlobalService.contracts.length === 1 ? this.contractsGlobalService.contracts[0] : null;
    }
  }

  async ngOnInit() {
    this.loading = true;
    let appraisaLocalStorage: any = JSON.parse(localStorage.getItem('emitNewAppraisal'));
    const currentUser = this.storageService.get(StorageKey.currentUser);
    if (this.initialState?.newAppraisal && appraisaLocalStorage?.technicianUserId !== currentUser.id) {
      appraisaLocalStorage = null;
    }
    if (this.initialState?.newAppraisal) {
      appraisaLocalStorage = null;
    }
    delete this.initialState?.newAppraisal;
    this.appraisal = appraisaLocalStorage || this.initialState as Appraisal || new Appraisal();
    if (this.initialState?.id) {
      this.appraisal = this.initialState as Appraisal;
    }
    if (this.appraisal.contractId == null && this.contractGlobal != null) {
      this.appraisal.contractId = this.contractGlobal;
    }
    const contractId = this.contractGlobal || this.appraisal.contractId;
    await this.companyService.getAll().then(list => {
      this.companies = list;
    });
    await this.getContracts(contractId);
    this.createForm();
    if (contractId != null) {
      await this.filterContract(contractId);
    }
    if (this.appraisal.manufacturerCompanyId || this.appraisal.responsibleCompanyId) {
      this.setCompanies(this.appraisal.manufacturerCompanyId, this.appraisal.responsibleCompanyId);
    }
    await this.getUsers(currentUser.id);
    if (this.appraisal?.id) {
      this.fillFromSnapshot();
    }
    if (!this.initialState?.id) {
      this.loading = false;
    }
  }

  async getContracts(contractId = null) {
    const currentUser = this.storageService.get(StorageKey.currentUser);
    let contractIds = [];
    if (!currentUser.superUser) {
      const currentPermissions = this.storageService.get(StorageKey.currentPermissions);
      contractIds = currentPermissions &&
        currentPermissions.filter(contractPermission =>
          contractPermission?.actionIds?.indexOf('UpdateAppraisal') >= 0 ||
          contractPermission?.actionIds?.indexOf('CreateAppraisal') >= 0).map(m => m.contractId);

      if (contractId) {
        contractIds = contractIds.filter(id => id === contractId);
      }
    }
    await this.contractService.list({}).then(async (res) => {
      this.contracts = res.result;
      if (contractIds.length > 0) {
        this.contracts = this.contracts.filter(c => contractIds.includes(Number(c.id)));
      }
    });
  }

  async getUsers(userId) {
    const userTechnicianUserId = this.appraisal.technicianUserId || null;
    if (userTechnicianUserId) {
      userId = userTechnicianUserId;
    }
    await this.userService.getAll({ order: 'name' }).then(resUsers => {
      resUsers.map(user => {
        if (user.name && (user.adminUser || user.adminManagerUser)) {
          this.users.push(user);
        }
        if (user.id === userId) {
          this.appraisalForm.get('technicianUserId').setValue(user.id);
        }
        if (this.appraisal?.signature?.representativeUserId > 0) {
          this.appraisalForm.get('representativeUserId').setValue(this.appraisal.signature.representativeUserId);
        }
      });
    });
  }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy() {
    if (this.isSaveLocalStorage) {
      const data = this.getAppraisalForm();
      localStorage.setItem('emitNewAppraisal', JSON.stringify(data));
    }
  }

  createForm(): void {
    const currentUser = this.storageService.get(StorageKey.currentUser);
    this.appraisalForm = this.formBuilder.group({
      contractId: [this.appraisal.contractId || this.contractGlobal, [Validators.required]],
      technicianUserId: [this.appraisal?.technicianUserId || currentUser?.id, [Validators.required]],
      representativeUserId: [this.appraisal?.signature?.representativeUserId || '', [Validators.required]],
      ordinanceApproveNumber: [this.appraisal?.ordinanceApproveNumber || ''],
      experimentDate: [this.appraisal?.experimentDate || '', [Validators.required, this.validateDate]],
      validateInitial: [this.appraisal?.validateInitial || '', [Validators.required, this.validateDate]],
      equipmentId: [this.appraisal?.equipment?.id || '', [Validators.required]],
      serialNumber: [this.appraisal?.AppraisalEquipment?.serialNumber || ''],
      equipment: [this.appraisal?.equipment || null],
      spotId: [this.appraisal?.spotId || ''],
      laneId: [this.appraisal?.laneId || ''],
      manufacturerCompanyId: [this.appraisal?.manufacturerCompanyId || '', [Validators.required]],
      manufacturerName: [''],
      manufacturerCompanyName: [''],
      equipmentModelName: [''],
      equipmentModelInstrument: [''],
      mainSeals: [this.appraisal?.equipment?.mainSeals || '', [Validators.required]],
      secondarySeals: [this.appraisal?.equipment?.secondarySeals || ''],
      additionalSerialNumber: [''],
      additionalMainSeals: [this.appraisal?.equipment?.additionalMainSeals || '', [Validators.required]],
      responsibleCompanyId: [this.appraisal?.responsibleCompanyId || '', [Validators.required]],
      serviceCode: [this.appraisal?.serviceCode || ''],
      value: [this.appraisal?.value || ''],
      signature: [this.appraisal?.signature || ''],
      laneDescription: [''],
      laneDirection: [''],
      laneSpeedsRegularVehicles: [''],
      manufacturerCompanyCnpj: [''],
      manufacturerCompanyAdress: [''],
      manufacturerCompanyZipcode: [''],
      manufacturerCompanyNeighbor: [''],
      manufacturerCompanyCity: [''],
      responsibleCompanyCnpj: [''],
      responsibleCompanyAdress: [''],
      responsibleCompanyZipcode: [''],
      responsibleCompanyNeighbor: [''],
      responsibleCompanyCity: [''],
    });
    const now = moment(new Date()).format('YYYY-MM-DD');
    const startsAt = this.appraisalForm.get('experimentDate');
    const endsAt = this.appraisalForm.get('validateInitial');
    if (!this.appraisal?.experimentDate) {
      startsAt.setValue(now);
    } else {
      startsAt.setValue(moment(startsAt.value).format('YYYY-MM-DD'));
    }
    if (!this.appraisal?.validateInitial) {
      endsAt.setValue(moment(new Date()).add(12, 'M').format('YYYY-MM-DD'));
    } else {
      endsAt.setValue(moment(endsAt.value).format('YYYY-MM-DD'));
    }

    this.appraisalForm.get('contractId').valueChanges.subscribe(value => {
      this.filterContract(value);
    });

    this.appraisalForm.get('serviceCode').setValue('26236');
    this.appraisalForm.get('value').setValue('R$ 542,72');
    this.appraisalForm.get('manufacturerCompanyId').valueChanges.subscribe(value => {
      const company = this.companies.find(c => c.id === value);
      this.appraisalForm.get('manufacturerCompanyCnpj').setValue(company?.cnpj);
      this.appraisalForm.get('manufacturerCompanyAdress').setValue(company?.Address?.street);
      this.appraisalForm.get('manufacturerCompanyZipcode').setValue(company?.Address?.zipcode);
      this.appraisalForm.get('manufacturerCompanyNeighbor').setValue(company?.Address?.neighborhood);
      let cityName = '';
      if (company?.City?.name && company?.City?.State?.abbreviation) {
        cityName = `${company?.City?.name}-${company?.City?.State?.abbreviation}`;
      }
      this.appraisalForm.get('manufacturerCompanyCity').setValue(cityName);
    });

    this.appraisalForm.get('responsibleCompanyId').valueChanges.subscribe(value => {
      const company = this.companies.find(c => c.id === value);
      this.appraisalForm.get('responsibleCompanyCnpj').setValue(company?.cnpj);
      this.appraisalForm.get('responsibleCompanyAdress').setValue(company?.Address?.street);
      this.appraisalForm.get('responsibleCompanyZipcode').setValue(company?.Address?.zipcode);
      this.appraisalForm.get('responsibleCompanyNeighbor').setValue(company?.Address?.neighborhood);
      let cityName = '';
      if (company?.City?.name && company?.City?.State?.abbreviation) {
        cityName = `${company?.City?.name}-${company?.City?.State?.abbreviation}`;
      }
      this.appraisalForm.get('responsibleCompanyCity').setValue(cityName);
    });
    this.appraisalForm.valueChanges.subscribe(() => {
      this.isValid = this.appraisalForm.valid;
    });

    this.appraisalForm.get('technicianUserId').valueChanges.subscribe(value => {
      this.technicianUserId = value;
    });
  }

  setCompanies(manufacturerCompanyId = null, responsibleCompanyId = null) {
    let company = null;
    let cityName = '';
    if (manufacturerCompanyId) {
      company = this.companies.find(c => c.id === manufacturerCompanyId);
      this.appraisalForm.get('manufacturerCompanyCnpj').setValue(company?.cnpj);
      this.appraisalForm.get('manufacturerCompanyAdress').setValue(company?.Address?.street);
      this.appraisalForm.get('manufacturerCompanyZipcode').setValue(company?.Address?.zipcode);
      this.appraisalForm.get('manufacturerCompanyNeighbor').setValue(company?.Address?.neighborhood);
      if (company?.City?.name && company?.City?.State?.abbreviation) {
        cityName = `${company?.City?.name}-${company?.City?.State?.abbreviation}`;
      }
      this.appraisalForm.get('manufacturerCompanyCity').setValue(cityName);
    }
    company = null;
    cityName = '';
    if (responsibleCompanyId) {
      company = this.companies.find(c => c.id === responsibleCompanyId);
      this.appraisalForm.get('responsibleCompanyCnpj').setValue(company?.cnpj);
      this.appraisalForm.get('responsibleCompanyAdress').setValue(company?.Address?.street);
      this.appraisalForm.get('responsibleCompanyZipcode').setValue(company?.Address?.zipcode);
      this.appraisalForm.get('responsibleCompanyNeighbor').setValue(company?.Address?.neighborhood);
      if (company?.City?.name && company?.City?.State?.abbreviation) {
        cityName = `${company?.City?.name}-${company?.City?.State?.abbreviation}`;
      }
      this.appraisalForm.get('responsibleCompanyCity').setValue(cityName);
    }
  }

  fillFromSnapshot() {
    const equipment = this.appraisal?.AppraisalEquipment;
    if (equipment) {
      this.appraisalForm.get('serialNumber').setValue(equipment.serialNumber);
      this.appraisalForm.get('manufacturerName').setValue(equipment.manufacturerName);
      this.appraisalForm.get('equipmentModelName').setValue(equipment.modelName);
      this.appraisalForm.get('equipmentModelInstrument').setValue(equipment.instrument);
      this.appraisalForm.get('additionalSerialNumber').setValue(equipment.additionalSerialNumber);
      this.equipmentModelCategory = equipment.category;
    }
    const lane = this.appraisal?.AppraisalLane;
    if (lane) {
      this.appraisalForm.get('laneDescription').setValue(lane.clientDescription);
      this.appraisalForm.get('laneDirection').setValue(lane.direction);
      this.appraisalForm.get('laneSpeedsRegularVehicles').setValue(lane.speed);
    }
    const companies = this.appraisal?.AppraisalCompanies || [];
    const manufacturer = companies.find(company => company.type === 'manufacturer');
    if (manufacturer) {
      this.appraisalForm.get('manufacturerCompanyCnpj').setValue(manufacturer.cnpj);
      this.appraisalForm.get('manufacturerCompanyAdress').setValue(manufacturer.street);
      this.appraisalForm.get('manufacturerCompanyZipcode').setValue(manufacturer.zipcode);
      this.appraisalForm.get('manufacturerCompanyNeighbor').setValue(manufacturer.neighborhood);
      this.appraisalForm.get('manufacturerCompanyCity').setValue(
        manufacturer.city && manufacturer.state ? `${manufacturer.city}-${manufacturer.state}` : ''
      );
    }
    const responsible = companies.find(company => company.type === 'responsible');
    if (responsible) {
      this.appraisalForm.get('responsibleCompanyCnpj').setValue(responsible.cnpj);
      this.appraisalForm.get('responsibleCompanyAdress').setValue(responsible.street);
      this.appraisalForm.get('responsibleCompanyZipcode').setValue(responsible.zipcode);
      this.appraisalForm.get('responsibleCompanyNeighbor').setValue(responsible.neighborhood);
      this.appraisalForm.get('responsibleCompanyCity').setValue(
        responsible.city && responsible.state ? `${responsible.city}-${responsible.state}` : ''
      );
    }
  }

  validateDate = () => {
    let message = null;
    if (this.appraisalForm) {
      const now = moment(new Date()).format('YYYY-MM-DD');
      const startDate = this.appraisalForm.get('experimentDate');
      const endDate = this.appraisalForm.get('validateInitial');
      const diffDays = moment(endDate.value).diff(moment(startDate.value), 'days');
      if (moment(startDate.value).isValid() && moment(endDate.value).isValid() && diffDays < 365) {
        message = {
          isLowerThanOneYear: 'Fields startDate and endDate less 365 days'
        };
      }
      if (moment(startDate.value).isValid() && moment(endDate.value).isValid() && startDate.value && endDate.value < startDate.value) {
        message = {
          invalidPeriod: 'Fields startDate greater than endDate'
        };
      }
    }
    return message;
  };

  async filterContract(contractId: any) {
    this.spots = (this.allSpots.length > 0 &&
      this.allSpots.filter(spot => spot.contractId === contractId)) || [];
    if (this.spots.length === 0) {
      await this.loadSpots(contractId);
    } else {
      this.lanes = this.allLanes.filter(lane => lane.contractId === contractId);
      this.equipments = this.allEquipments.filter(equipment => equipment.contractId === contractId);
      this.calibrations = this.allCalibrations.filter(calibration => calibration.contractId === contractId);
    }
  }

  async filterEquipment(equipmentId: any) {
    const equipment = this.allEquipments.find(e => e.id === equipmentId);
    this.spots = this.allSpots.filter(s => equipment.spotIds.includes(s.id));
    if (this.spots.length === 1) {
      this.appraisalForm.get('spotId').setValue(this.spots[0].id);
    }
    this.lanes = this.allLanes.filter(l => equipment.laneIds.includes(l.id));
    if (this.lanes.length === 1) {
      this.appraisalForm.get('laneId').setValue(this.lanes[0].id);
    }
    if (equipment?.equipmentModelId) {
      await this.equipmentModelService.getById(equipment.equipmentModelId).then(async (equipmentModel) => {
        await this.manufacturerService.getById(equipmentModel.manufacturerId).then(manufacturer => {
          this.appraisalForm.get('manufacturerName').setValue(manufacturer.name);
          this.appraisalForm.get('equipmentModelName').setValue(equipmentModel?.name);
          this.appraisalForm.get('equipmentModelInstrument').setValue(equipmentModel?.instrument);
          if (equipment.additionalSerialNumber != null) {
            this.appraisalForm.get('additionalSerialNumber').setValue(equipment.additionalSerialNumber);
          }
          const addMailSeals = this.appraisalForm.get('additionalMainSeals');
          if (!this.appraisal?.equipment?.additionalMainSeals) {
            addMailSeals.clearValidators();
            addMailSeals.updateValueAndValidity();
            addMailSeals.setValue(null);
          }
          if (equipmentModel.category === 'noIntrusive') {
            this.equipmentModelCategory = equipmentModel.category;
            this.appraisalForm.get('ordinanceApproveNumber').setValue('089/2021');
            this.appraisalForm.get('secondarySeals')
              .setValue('Dispensado o uso de lacre secundário, conforme modelo aprovado pela Portaria Inmetro 089/2021');
            addMailSeals.setValidators(Validators.required);
          } else if (equipmentModel.category === 'intrusive') {
            this.appraisalForm.get('ordinanceApproveNumber').setValue('228/2018');
            this.appraisalForm.get('secondarySeals')
              // eslint-disable-next-line max-len
              .setValue('Dispensado o uso de lacre secundário, conforme modelo aprovado pela portaria 190/2019 (Aditivo à Portaria 228/2018)');
            addMailSeals.clearValidators();
            addMailSeals.updateValueAndValidity();
            addMailSeals.setValue(null);
          }
        });
      });
    }
  }

  async loadSpots(contractId) {
    if (contractId != null) {
      await this.spotService.list({ contractId }).then(resSpot => {
        const spots = resSpot.result;
        this.allSpots = spots;
        this.spots = this.allSpots.filter(spot => spot.contractId === contractId);
        this.laneService.list({ contractId }).then(res => {
          this.lanes = res.result;
          this.allLanes = res.result;
        });
      });

      await this.equipmentService.list({ contractId }).then(res => {
        this.equipments = res.result;
        this.allEquipments = res.result;
      });

      await this.calibrationService.list({ contractId }).then(async (resCalibrations) => {
        this.allCalibrations = resCalibrations.result;
        this.calibrations = this.allCalibrations;
      });

      if (this.appraisal?.equipment?.id) {
        await this.filterEquipment(this.appraisal.equipment.id);
      }

      if (this.appraisal?.laneId) {
        this.setLane(this.appraisal?.laneId);
      }
    }
    this.loading = false;
  }

  setLanes(spotId) {
    if (spotId > 0) {
      this.lanes = this.allLanes.filter(lane => spotId === lane.spotId);
      if (this.lanes.length === 1) {
        this.appraisalForm.get('laneId').setValue(this.lanes[0].id);
        this.setLane(this.lanes[0].id);
      }
    }
  }

  setLane(laneId) {
    this.lane = this.allLanes.find(lane => lane.id === laneId);
    if (this.lane?.clientDescription) {
      this.appraisalForm.get('laneDescription').setValue(this.lane.clientDescription);
    }
    if (this.lane?.direction) {
      this.appraisalForm.get('laneDirection').setValue(this.lane.direction);
    }
    if (this.lane?.speeds?.regularVehicles) {
      this.appraisalForm.get('laneSpeedsRegularVehicles').setValue(this.lane?.speeds?.regularVehicles);
    }
  }

  setEquipments() {
    const equipmentIds = this.calibrations.map(c => c.equipmentId);
    this.equipments = this.allEquipments.filter(e => equipmentIds.includes(e.id));
  }

  getAppraisalForm() {
    const contractId = this.appraisalForm.get('contractId').value;
    const technicianUserId = this.appraisalForm.get('technicianUserId').value;
    const ordinanceApproveNumber = this.appraisalForm.get('ordinanceApproveNumber').value;
    const experimentDate = moment(this.appraisalForm.get('experimentDate').value).format();
    const validateInitial = moment(this.appraisalForm.get('validateInitial').value).format();
    const equipment = {
      id: this.appraisalForm.get('equipmentId').value,
      mainSeals: this.appraisalForm.get('mainSeals').value,
      secondarySeals: this.appraisalForm.get('secondarySeals').value || '',
      additionalMainSeals: this.appraisalForm.get('additionalMainSeals').value || '',
    };
    const spotId = this.appraisalForm.get('spotId').value;
    const laneId = this.appraisalForm.get('laneId').value;
    const manufacturerCompanyId = this.appraisalForm.get('manufacturerCompanyId').value;
    const responsibleCompanyId = this.appraisalForm.get('responsibleCompanyId').value;
    const serviceCode = this.appraisalForm.get('serviceCode').value;
    const value = 542.72;
    const signature = {
      technicianUserId: this.appraisalForm.get('technicianUserId').value,
      representativeUserId: this.appraisalForm.get('representativeUserId').value,
    };
    let experimentCode = '';
    if (this.appraisal?.id) {
      experimentCode = this.appraisal.experimentCode;
    }

    const data: any = {
      contractId,
      technicianUserId,
      ordinanceApproveNumber,
      experimentDate,
      validateInitial,
      equipment,
      spotId,
      laneId,
      manufacturerCompanyId,
      responsibleCompanyId,
      serviceCode,
      value,
      signature,
      experimentCode
    };
    if (data.spotId === '') {
      delete data.spotId;
    }
    if (data.laneId === '') {
      delete data.laneId;
    }
    if (data.signature.technicianUserId === '') {
      delete data.signature.technicianUserId;
    }
    if (data.signature.representativeUserId === '') {
      delete data.signature.representativeUserId;
    }
    const appraisal = Appraisal.create(data);
    return appraisal;
  }

  public async onAllSubmited() {
    if (this.promise != null) {
      return this.promise;
    }
    try {
      const appraisal = this.getAppraisalForm();
      return this.appraisalService.list(
        {
          spotId: appraisal.spotId,
          laneId: appraisal.laneId,
          contractId: appraisal.contractId
        }).then(async resAppraisal => {
          let result = resAppraisal.result;
          if (this.appraisal?.id) {
            result = result.filter(res => res.id !== this.appraisal.id);
          }
          let appraisalConflict = false;
          for (const retAppraisal of result) {
            if ((moment(appraisal.experimentDate).format('YYYY-MM-DD') === moment(retAppraisal.experimentDate).format('YYYY-MM-DD')) ||
              (moment(appraisal.validateInitial).format('YYYY-MM-DD') === moment(retAppraisal.validateInitial).format('YYYY-MM-DD'))) {
              appraisalConflict = true;
            }
          }
          if (appraisalConflict) {
            await this.alertService.show(new AlertItem('AppraisalSaveConflict', AlertType.danger));
            localStorage.removeItem('emitNewAppraisal');
            this.isSaveLocalStorage = false;
          } else {
            if (this.appraisal?.id) {
              appraisal.id = this.appraisal.id;
              this.promise = this.appraisalService.update(appraisal);
            } else if (!this.appraisal?.id) {
              this.promise = this.appraisalService.create(appraisal);
            }
            this.promise.then(async res => {
              this.appraisal = res;
              localStorage.removeItem('emitNewAppraisal');
              this.isSaveLocalStorage = false;
              await this.alertService.show(new AlertItem('AppraisalSaved', AlertType.success));
              return res;
            }).catch(async error => {
              console.error(error);
              await this.alertService.show(new AlertItem('AppraisalSaveError', AlertType.danger));
              throw error;
            }).finally(() => {
              this.promise = null;
            });
          }
          return this.promise;
        });
    } catch (err) {
      console.error(err);
    }
    return this.promise;
  }

  unfoldMoreOrLessEquipment() {
    this.typeUnfoldEquipment = this.typeUnfoldEquipment === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldEquipment`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  unfoldMoreOrLessLocal() {
    this.typeUnfoldLocal = this.typeUnfoldLocal === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldLocal`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  unfoldMoreOrLessCompanyManufacturer() {
    this.typeUnfoldCompanyManufacturer = this.typeUnfoldCompanyManufacturer === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldCompanyManufacturer`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  unfoldMoreOrLessCompanyResponsible() {
    this.typeUnfoldCompanyResponsible = this.typeUnfoldCompanyResponsible === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldCompanyResponsible`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  unfoldMoreOrLessAssign() {
    this.typeUnfoldAssign = this.typeUnfoldAssign === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdUnfoldAssign`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }
}
